(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }
    if (typeof sm.portal.vm.euemployment === "undefined") {
        jQuery.extend(sm.portal.vm, { euemployment: {} });
    }

    function AnythingPopulated(employment){

        if (employment.DataList().length > 0) {
            for (var i = 0; i < employment.DataList().length; i++) {
                var dataItem = employment.DataList()[i];
                if (!sm.portal.utility.isNullOrEmpty(dataItem.EmploymentStatusID())) return true;
                if (!sm.portal.utility.isNullOrEmpty(dataItem.EmploymentStatus())) return true;
                if (!sm.portal.utility.isNullOrEmpty(dataItem.OccupationID())) return true;
                if (!sm.portal.utility.isNullOrEmpty(dataItem.Occupation())) return true;
                if (!sm.portal.utility.isNullOrEmpty(dataItem.EmployerID())) return true;
                if (!sm.portal.utility.isNullOrEmpty(dataItem.EmployerName())) return true;
                if (!sm.portal.utility.isNullOrEmpty(dataItem.BeginDate())) return true;
                if (!sm.portal.utility.isNullOrEmpty(dataItem.EndDate())) return true;
            }
        }
        return false;
    }

    function LoadModel(employment, container){
        if (container.Payload.EmploymentFull != null) {

            for (var i = 0; i < container.Payload.EmploymentFull.length; i++) {

                var employ     = container.Payload.EmploymentFull[i];
                var dateFormat = sm.resources.portalResource.getValue('DateFormatExample').toUpperCase();

                if (employ.BeginDate != null && employ.BeginDate != undefined) {
                    employ.BeginDate = moment(employ.BeginDate, 'YYYY-MM-DDTHH:mm:ss').format(dateFormat);
                }

                if (employ.EndDate != null && employ.EndDate != undefined) {
                    employ.EndDate = moment(employ.EndDate, 'YYYY-MM-DDTHH:mm:ss').format(dateFormat);
                }

                var newDataItem = new sm.portal.vm.EmploymentDataItem({
                    EmploymentStatusID: employ.EmploymentStatusID,
                    EmploymentStatus: employ.EmploymentStatus,
                    OccupationID: employ.OccupationID,
                    Occupation: employ.Occupation,
                    EmployerID: employ.EmployerID,
                    EmployerName: container.Payload.Employment.EmployerName,
                    BeginDate: employ.BeginDate,
                    EndDate: employ.EndDate,
                    EmploymentStatuses: employment.EmploymentStatuses,
                    Occupations: employment.Occupations,
                    ID: employ.ID,
                    GID: employ.GID
                });
                
                employment.DataList.push(newDataItem);
            }
        }
    }

    function ExtractATO(employmentViewModel){
        var atoList = Array();
        for (var i = 0; i < employmentViewModel.DataList().length; i++) {
            var dataListItem = employmentViewModel.DataList()[i];
            var ato = dataListItem.ExtractATO();
            atoList.push(ko.toJS(ato));
        }
        return atoList;
    }

    jQuery.extend(true, sm.portal.vm.euemployment, {
        AnythingPopulated: AnythingPopulated,
        LoadModel: LoadModel,
        ExtractATO: ExtractATO
    });

})(jQuery);